export const colors = {
  // Base
  white: '#fff',
  black: '#000',

  // Primarios
  verdeClaro: '#ACF1F9',
  primary: '#29D9C5',
  accent: '#00A19B',
  primaryText: '#006865',
  

  // Grises / Neutros
  gray100: '#f5f5f5',
  gray150: '#F2F2F2',
  gray200: '#EFEFEF',
  gray300: '#D9D9D9',
  gray50: '#FAFAFA',
  gray400: '#cccccc',
  gray600: '#666',
  gray700: '#333',

  // Bordes / fondos específicos
  borderLight: '#CACACA',
  borderSidebar: '#CFCFCF',
  resumenBg: '#ACF1F9',

  // Estados
  notFoundRed: '#FF6B6B',
  secondaryButton: '#6C757D',

  // Advertencia
  warnBg: '#FFF4E5',
  warnBorder: '#E6C10E',
  warnShadow: 'rgba(251, 140, 0, 0.2)',
  warnIcon: '#F57C00',
  warnText: '#8B5E00',

  // Error
  error: '#f44336',
  errorText: '#d32f2f',
  cancelar: '#EF9A9A',
  errorBg: '#FFEBEE',
  naranja: '#EB996E',
  errorShadow: 'rgba(244, 67, 54, 0.2)',

  // Éxito
  success: '#4CAF50',
  successBg: '#E8F5E9',

  // Información
  infoBg: '#E3F2FD',
  infoBorder: '#2196F3',
  infoText: '#1565C0',

  // Alertas específicas
  alertWpBg: '#FFECEC',
  alertWpBorder: '#F5C2C7',
  alertWpText: '#912D2B',

  // Tabla
  tableShadow: 'rgba(0, 0, 0, 0.1)',

  // Inputs
  inputBg: '#F5F5F5',
  inputBorder: '#e9ecef',

  // Botones
  delete: '#dc3545',
  deleteHover: '#c82333',

  // Alertas
  errorBorder: '#f5c6cb',
  successBorder: '#d4edda',
  errorBg2: '#f8d7da',
  infoBg2: '#d1ecf1',
  errorText2: '#721c24',
  infoText2: '#0c5460',

  // Tabla
  tableRow: '#f8f9fa',
  tableShadow: 'rgba(0, 0, 0, 0.1)',

  // Texto
  textSecondary: '#6c757d'
};
